export default "__VITE_ASSET__C8eJ6$Vs__";